import { render } from "./CategorySection.vue?vue&type=template&id=e5ee4978"
import script from "./CategorySection.vue?vue&type=script&lang=js"
export * from "./CategorySection.vue?vue&type=script&lang=js"
script.render = render

export default script